import { render, staticRenderFns } from "./awaitingModal.vue?vue&type=template&id=627f9b86"
import script from "./awaitingModal.vue?vue&type=script&lang=js"
export * from "./awaitingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports